<template>
  <CFormCheck
    :id="id"
    type="checkbox"
    :model-value="checked"
    :label="label"
    @update:model-value="$emit('update:checked', $event)"
  />
</template>

<script>
import { CFormCheck } from '@coreui/vue-pro'

export default {
  name: 'CInputCheckbox',
  components: { CFormCheck },
  props: {
    checked: { type: Boolean, default: false },
    label: { type: String, default: '' },
    id: { type: String, default: '' },
  },
  emits: ['update:checked'],
}
</script>
